import { render, staticRenderFns } from "./DirectionalStudents.vue?vue&type=template&id=5d2491df&scoped=true"
import script from "./DirectionalStudents.vue?vue&type=script&lang=js"
export * from "./DirectionalStudents.vue?vue&type=script&lang=js"
import style0 from "./DirectionalStudents.vue?vue&type=style&index=0&id=5d2491df&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2491df",
  null
  
)

export default component.exports